export default __webpack_public_path__ + "static/media/googleSheets.52df943a.png";